// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"bambuser-handler","506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] || chunkId) + "." + {"99":"78f047a5","280":"56caa3eb","506":"49c3797c","536":"cfb17539","889":"2892de7d"}[chunkId] + ".js";
};